/* eslint-disable @typescript-eslint/naming-convention */
import { intersection } from 'lodash';

declare global {
  /** Add global functions to Window type */
  interface Window {
    logError: any;
    debug: any;
    log: any;
    Promise: any;
    currentComponent: any;
    CDN_URL: string;
  }

  function debug(type: any, ...args: any[]): void;

  function logError(...args: any[]): void;

  function log(...args: any[]): void;

  const ng: any;

  function currentComponent(): any;
}

window.debug = (type: any, ...args: any[]) => {
  const processedType: any[] = typeof type === 'string' ? [type] : type;

  let match: string[] = location.hash.match(/\?(.*)$/);
  let query: { [id: string]: string } = {};
  if (match && match.length) {
    match[1].split('&').forEach((i) => {
      let [key, val] = i.split('=');
      query[key] = val;
    });
  }
  if (query.debug) {
    localStorage.debug = query.debug;
  }

  let ns = localStorage.debug;
  if (ns) {
    ns = ns.split(',');
  }

  if (
    (ns != null ? ns.length : undefined) &&
    (ns[0] === 'true' || (typeof ns === 'object' && intersection(ns, processedType).length))
  ) {
    const prefix = `${Date.now()} [${processedType.toString()}]`;
    console.log(prefix, ...args);
  }

  return null;
};

window.logError = (...args: any[]) => {
  const prefix = `${Date.now()} [ERROR]`;
  console.error(prefix, ...Array.from(args));

  return null;
};

window.log = (...args: any) => {
  const prefix = `${Date.now()}`;
  console.log(prefix, ...Array.from(args));

  return null;
};

window.Promise = Promise;

window.currentComponent = () => ng.probe(document.querySelector('.ng-star-inserted')).context;

// This is for accessing the above with wicked-fast syntax since hopefully it will be used a lot
// So you can just do 'cc.<any prop defined on component>' to instantly check context.
Object.defineProperty(window, 'cc', {
  get: () => window.currentComponent()
});

// Typescript is whiny and won't let you declare a module without an export
// removing this causes legions of problems
export {};
